

import {PROJECT_URL, UPLOAD_URL} from "../util/urlconstants";

import {apiSlice} from "../features/apiSlice"

export const projectApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getAllProjects: builder.query({
            //@ts-ignore
            query: (body: any) => ({
                url: PROJECT_URL,
                method: "GET",
                body: body
            }),
            keepUnusedDataFor: 5,
            //@ts-ignore
            providesTags: ["Project"],
        }),
        getProject: builder.query({
            query: (id: string) => ({
                url: `${PROJECT_URL}/${id}`,
                method: "GET",
            })
        }),
        getMyProject: builder.query({
            query: (id: string) => ({
                url: `${PROJECT_URL}/user/${id}`,
                method: "GET",
            }),
            keepUnusedDataFor: 5,
            providesTags: ["Project"],
        }),
        listAllProjectEmployees:builder.query({
           query: (body:any) => ({
               url: `${PROJECT_URL}/employeesList`,
               method: "GET",
               body: body
           }) ,
            keepUnusedDataFor: 5,
            providesTags: ["Project", "ProjectEmployee"],
        }),
        fetchAssignedProjectByUser: builder.query({
            query: (userId: string) => ({
                url: `${PROJECT_URL}/all/${userId}`,
                method: "GET",
            }),
            keepUnusedDataFor: 5,

            providesTags: ["ProjectEmployees"],
        }),
        assignEmployeeToProject: builder.mutation({
            query: ({ userId,
                      projectId} : {
                      userId: string,
                      projectId: string
            }) => ({
                url: `${PROJECT_URL}/${projectId}/employees/${userId}`,
                method: "POST",
                body: {
                    userId,
                    projectId
                }
            }),
            invalidateTags:["ProjectEmployees"],
        }),
        removeEmployeeFromProject: builder.mutation({
            query: (    { userId,
                        projectId} : {
                userId: string,
                projectId: string
            }) => ({
                url: `${PROJECT_URL}/${projectId}/employees/${userId}`,
                method: "DELETE",
                body: {
                    userId,
                    projectId
                }
            }),
            invalidateTags:["ProjectEmployees"],
        }),
        createProject: builder.mutation({
            query: (data: any) => ({
                url: PROJECT_URL,
                method: "POST",
                body: data,
            }),
            invalidateTags:["Project"]
        }),
        updateProject: builder.mutation({
            query: ({
                id,
                projectName,
                description,
                projectNumber,
                location,
                contractor
                    } : {
                id: string,
                projectName: string,
                description: string,
                projectNumber: string,
                location: string,
                contractor: string,
            }) => ({
                url: `${PROJECT_URL}/${id}`,
                method: "PUT",
                body: {
                    id,
                    projectName,
                    description,
                    projectNumber,
                    location,
                    contractor,
                }
            }),
            invalidateTags:["Project", "Project Employees"],
        }),
        deleteProject: builder.mutation({
            query: (id: string) => ({
                url: `${PROJECT_URL}/${id}`,
                method: "DELETE",
            })
        }),
        sendAIProjectMessage: builder.mutation({
            query: (session: any) => ({
                url: `${PROJECT_URL}/projectChat`,
                method: "POST",
                body: session,
            }),
            invalidatesTags:["Chat"]
        }),
        uploadProjectImage: builder.mutation({
            query: (data: any) => ({
                url: `${UPLOAD_URL}`,
                method: "POST",
                body: data
            })
        }),
    })
});

export const {
    useGetAllProjectsQuery,
    useGetProjectQuery,
    useGetMyProjectQuery,
    useFetchAssignedProjectByUserQuery,
    useCreateProjectMutation,
    useUpdateProjectMutation,
    useDeleteProjectMutation,
    useAssignEmployeeToProjectMutation,
    useRemoveEmployeeFromProjectMutation,
    useSendAIProjectMessageMutation,
    useListAllProjectEmployeesQuery,
    useUploadProjectImageMutation,
} = projectApiSlice;

